import React from "react";
import { Card, Button, ListGroup, Row, Col, Media } from "react-bootstrap";
import PlaceholderImage from "../../sharedComponents/placeholderImage";
import CenteredLoadingIndicator from "../../sharedComponents/centeredLoadingIndicator";
import { slice } from "lodash";
import NoContent from "../../sharedComponents/noItemFoundAlert";
import "./home.scss";

function FeaturedRecipies({ featuredRecipies, history }) {
	return (
		<Card className="featured-recipes-card-container">
			<Card.Header className="card-header">Featured Recipes</Card.Header>
			{featuredRecipies ? (
				featuredRecipies.length ? (
					<div className="list-container">
						<ListGroup variant="flush">
							{slice(featuredRecipies, 0, 3).map((item) => (
								<ListGroup.Item key={item.id}>
									<Media
										className="pointer"
										onClick={() => history.push(`/nutrition/recipes/${item.id}/details`)}>
										<PlaceholderImage
											src={item.images[0] && item.images[0].image_data.photo_s}
											width={60}
											height={60}
											bg="rgba(0,0,0,0.1)"
											color="rgba(0,0,0,0.3)"
											objectFit="cover"
											className="mr-3 img-custom-style"
										/>
										<Media.Body>
											<h5 className="mb-2">{item.name}</h5>
											<Row className="lh-18">
												<Col>
													<div className="list-item-data">{item.get_range_calorie} kcal</div>
													<div className="list-item-title">Calories</div>
												</Col>
												<Col>
													<div className="list-item-data">{item.get_range_carb} grams</div>
													<div className="list-item-title">Carbs</div>
												</Col>
												<Col>
													<div className="list-item-data">{item.get_range_protein} grams</div>
													<div className="list-item-title">Proteins</div>
												</Col>
											</Row>
										</Media.Body>
									</Media>
								</ListGroup.Item>
							))}
						</ListGroup>
						<Button
							variant="outline-secondary"
							className="footer-button"
							onClick={() => {
								history.push("/nutrition/recipes");
							}}>
							View And Search All Recipes
						</Button>
					</div>
				) : (
					<div className="m-3">
						<NoContent />
					</div>
				)
			) : (
				<CenteredLoadingIndicator />
			)}
		</Card>
	);
}

export default FeaturedRecipies;
